import React, { useState } from 'react';
import IconButtonSvg from '../../utilities/icon_button_svg';

import styles from './index.module.css';

const ExportButton = ({ requestExport, params, style = {} }) => {
  const [isDisabled, setIsDisabled] = useState(false);

  return (
    <div className={styles.export_button} style={style}>
      <IconButtonSvg
        icon={
          <svg width='15' height='16' viewBox='0 0 15 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <g clipPath='url(#clip0_2245_12790)'>
              <path
                d='M13.125 10.8125V14.5625H1.875V10.8125M7.5 2.375V11.75M3.75 6.125L7.5 2.375L11.25 6.125'
                stroke='#F5F7F9'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </g>
            <defs>
              <clipPath id='clip0_2245_12790'>
                <rect width='15' height='15' fill='white' transform='translate(0 0.5)' />
              </clipPath>
            </defs>
          </svg>
        }
        text='Export'
        useDisabled={true}
        onClick={async () => {
          if (!params) return;
          return requestExport(params);
        }}
      />
    </div>
  );
};

export default ExportButton;
